import React from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";

import { getFloor } from "./../../../utils/helpers";
import InputTypeText from "./../../../components/InputTypeText";

import {
  betTypesForBetBetslip,
  betTypesForBetsContainer,
} from "./../../../utils/constants";

const BetsList = ({
  maxStake,
  minStake,
  onChangeStakeEventListener,
  eventObj,
  eventId,
  onRemoveOneEventsBetsEventListener,
  currency,
  isLowCredits,
  preNumbersUOText,
  firstNumberUOText,
}) => {
  const { t } = useTranslation();

  // Helper to safely check if tip includes SYSTEM
  const isSystemBet = (tip) => {
    if (typeof tip === 'object') {
      return Object.values(tip).some(value => typeof value === 'string' && value.includes("SYSTEM"));
    }
    return typeof tip === "string" && tip.includes("SYSTEM");
  };

  // Helper to get SYSTEM description text
  const getSystemBetLabel = (resultArray) => {
    const count = Array.isArray(resultArray) ? resultArray.length : 0;
    if (count >= 7 && count <= 10) {
      return `SYSTEM 6/${count}`;
    }
    return null;
  };

  // Helper to get the correct bet type for comparison
  const getBetTypeForComparison = (tip) => {
    if (typeof tip === 'string') return tip;
    if (typeof tip === 'object') {
      const systemValue = Object.values(tip).find(value => 
        typeof value === 'string' && value.includes("SYSTEM")
      );
      return systemValue || 'SYSTEM';
    }
    return String(tip);
  };

  return (
    <ul className="column-list event-bets-block-list">
      {eventObj.map((oneBet, j) => {
        const rawBetTip = Object.keys(oneBet)[0];
        const betTip = typeof rawBetTip === "string" ? rawBetTip : rawBetTip.toString();
        const oneBetProps = oneBet[betTip];

        // Prepare proper tip label
        let displayTip = oneBetProps.tip;
        let displayTipName = oneBetProps.tip;

        // If it's a System bet, override the label
        const systemLabel = getSystemBetLabel(oneBetProps.result);
        if (systemLabel) {
          displayTip = systemLabel;
          displayTipName = systemLabel;
        }

        // Get the correct bet type for data attributes
        const betTypeForData = getBetTypeForComparison(oneBetProps.tip);
        
        // Check if this is a SYSTEM bet
        const isSystem = isSystemBet(oneBetProps.tip);

        return (
          <li className="event-bets-block-list-item" key={j}>
            <div className="bet-status">
              <span
                data-event-id={eventId}
                data-bet-type={betTypeForData}
                data-bet-type-name={t(displayTipName)}
                data-bet-result={
                  Array.isArray(oneBetProps.result)
                    ? oneBetProps.result.join(",")
                    : oneBetProps.result
                }
                onClick={onRemoveOneEventsBetsEventListener}
                className="close-button"
              ></span>

              <p className="bet-name">
                {oneBetProps.odds > 1
                  ? t(displayTip) + ` (${oneBetProps.odds})`
                  : t(displayTip)}
              </p>

              <span className="win">
                {oneBetProps.tip ===
                  betTypesForBetBetslip[
                    betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER
                  ] && `${oneBetProps.result}(${preNumbersUOText})`}

                {oneBetProps.tip ===
                  betTypesForBetBetslip[
                    betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER
                  ] && `${oneBetProps.result}(${firstNumberUOText})`}

                {oneBetProps.tip !==
                  betTypesForBetBetslip[
                    betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER
                  ] &&
                  oneBetProps.tip !==
                    betTypesForBetBetslip[
                      betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER
                    ] &&
                  Array.isArray(oneBetProps.result)
                    ? oneBetProps.result.join(",")
                    : oneBetProps.result}
              </span>
            </div>

            <div
              data-event-id={eventId}
              data-bet-type={betTypeForData}
              className={cn("bet-stake", {
                'system-bet': isSystem, // Додаємо спеціальний клас для SYSTEM ставок
              })}
            >
              <label htmlFor={`${eventId}+${j}`} className="bet-stake-label">
                {t("betslip.betstake")}, {currency}
              </label>
              <InputTypeText
                id={`${eventId}+${j}`}
                onChangeEvent={isSystem ? undefined : onChangeStakeEventListener}
                dataEventId={eventId}
                dataBetType={betTypeForData}
                value={getFloor(oneBetProps.stake, 100)}
                classNames={cn(`stake-amount-input stake-amount`, {
                  'system-input': isSystem, // Спеціальний клас для input SYSTEM ставок
                  danger:
                    isLowCredits ||
                    oneBetProps.stake > maxStake ||
                    oneBetProps.stake < minStake,
                })}
                readOnly={isSystem}
                disabled={isSystem} // Додаємо disabled для кращої візуалізації
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default BetsList;